/**
 * Created by @author @ddennis - ddennis.dk aka fantastisk.dk/works aka meresukker.dk on 23/02/2024.
 */
import React, { useEffect } from 'react'
import { Input } from 'antd'
import { FormLabel } from './FormLabel'
const { TextArea } = Input

type JustificationProps = {
  formHook: any
  label?: string
  id?: string
}
export const FormJustification = ({
  formHook,
  label = 'Justification for change',
  id = 'justification',
}: JustificationProps) => {
  const {
    register,
    setValue,
    unregister,
    formState: { errors },
  } = formHook

  const errorMsg = 'A justification is required to proceed'
  const errorState = errors[id]
  const errorMessage = errorState && errorState.message ? (errorState.message as string) : errorMsg

  useEffect(() => {
    register(id, { required: true })

    return () => {
      unregister(id)
    }
  }, [register, unregister, id])

  const onChangeHandler = (val: string) => {
    setValue(id, val)
  }

  return (
    <div>
      <FormLabel label={label} />
      <TextArea
        id={id}
        rows={3}
        onChange={(e) => onChangeHandler(e.target.value)}
        placeholder="Please provide a justification for this update "
        defaultValue=""
        showCount
        maxLength={100}
      />
      {errorState ? <div className="p-small text-danger">{errorMessage}</div> : null}
    </div>
  )
}
